import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@material-ui/core';
import {
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
} from 'reactstrap';
import {
  CloudUpload,
  Visibility,
  Delete,
  Description,
  Close,
  GetApp,
  InsertDriveFile,
} from '@mui/icons-material';
import Backdrop from '@material-ui/core/Backdrop';
import './ChartPage.css';
import React, { useEffect, useRef, useState } from 'react';
import Alert from '@material-ui/lab/Alert';
import moment from 'moment';
import Button1 from 'reactstrap/lib/Button';
import axios from '../axios';
import Snackbar from '@material-ui/core/Snackbar';
import numeral from 'numeral';
import { makeStyles } from '@material-ui/core/styles';
import Spinner from 'react-spinkit';
import { useHistory } from 'react-router-dom';
import PreviewIcon from '@mui/icons-material/Preview';
import {
  Grid,
  Button,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Paper,
  Divider,
  Tooltip,
  Chip,
  styled,
} from '@mui/material';

const UploadButton = styled(Button)(({ theme }) => ({
  '&&': {
    textTransform: 'none',
    borderRadius: '4px',
    width: '100%',
    padding: '7px 14px',
    marginTop: '10px',
    fontWeight: 500,
    boxShadow: 'none',
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      boxShadow: 'none',
      color: 'white',
    },
  },
  '&& .MuiButton-startIcon': {
    marginRight: '8px',
  },
}));

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
  },
}));

const DocumentUploadCard = ({
  title,
  inputRef,
  file,
  onFileChange,
  onPreview,
  onRemove,
}) => {
  console.log(file, 'file');
  return (
    <Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 500 }}>
        {title}
      </Typography>

      <input
        ref={inputRef}
        onChange={e => onFileChange(e.target.files[0])}
        type="file"
        accept=".jpg,.jpeg,.png,.docx,.xlsx,.pdf"
        style={{ display: 'none' }}
      />

      {!file || (!file.name && !file.url) ? (
        <UploadButton
          variant="outlined"
          startIcon={<CloudUpload />}
          onClick={() => inputRef.current.click()}
        >
          Upload Document
        </UploadButton>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Description color="primary" sx={{ mr: 2 }} />
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            {file.size && <Typography variant="caption" color="text.secondary">
              {(file.size / 1024).toFixed(1)} KB
            </Typography>}
          </Box>
          <Tooltip title="Preview">
            <IconButton onClick={() => { onPreview(file) }} color="primary">
              <Visibility />
            </IconButton>
          </Tooltip>
          <Tooltip title="Remove">
            <IconButton onClick={onRemove} color="error">
              <Delete />
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Paper>
  );
};

function POStatusUpdate(props) {
  const classes = useStyles();
  const history = useHistory();
  const [open, setopen] = useState(false);
  const [open1, setopen1] = useState(false);
  const [open2, setopen2] = useState(false);
  const [open3, setopen3] = useState(false);
  const [open4, setopen4] = useState(false);
  const pages = [
    500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700,
    1800, 1900, 2000, 2100, 2200, 2300, 2400, 2500, 2600, 2700, 2800, 2900,
    3000, 3100, 3200, 3300, 3400, 3500, 3600, 3700, 3800, 3900, 4000, 4100,
    4200, 4300, 4400, 4500, 4600, 4700, 4800, 4900, 5000, 5100,
  ];
  const [page, setpage] = useState(0);
  const [rowsperpage, setrowsperpage] = useState(pages[page]);
  const [fromdatee, setfromdatee] = useState('');
  const [toodate, settoodate] = useState('');
  const [customerss, setcustomerss] = useState('');
  const [opeecreate, setopeecreate] = useState(false);
  const [pono, setpono] = useState('');
  const [deliverdate, setdeliverdate] = useState(new Date());
  const [totalamountvaluedata, settotalamountvaluedata] = useState(0);
  const [savespinners, setsavespinners] = useState(false);
  const [CStatecodeee, setCStatecodeee] = useState('');
  const [Frommail, setFrommail] = useState('');
  const [Tomail, setTomail] = useState('');
  const [smptport, setsmptport] = useState('');
  const [SMTPServer, setSMTPServer] = useState('');
  const [mailpassword, setmailpassword] = useState('');
  const [ccmail, setccmail] = useState('');
  const [referenceNumber, setReferenceNumber] = useState('');
  const [referenceDate, setReferenceDate] = useState(new Date());
  const [refremarks, setRefRemarks] = useState('');
  const [remark, setremark] = useState('');
  const [totaltax, settotaltax] = useState(0);
  const [totalqty, settotalqty] = useState(0);
  const [totalamt, settotalamt] = useState(0);
  const [TOtaligstamt, setTOtaligstamt] = useState(0);
  const [Total_discount_amt, setTotal_discount_amt] = useState(0);
  const [provalue, setProvalue] = useState([]);
  const [Statecodeee, setStatecodeee] = useState('');

  // Checkbox state
  const [isDeliveryChecked, setIsDeliveryChecked] = useState(false);
  const [isRemarksChecked, setIsRemarksChecked] = useState(false);

  const [previewModal, setPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState('');
  const [TrackId, setTrackId] = useState('');
  const [CourierPartner, setCourierPartner] = useState('');
  const [NoOfBoxes, setNoOfBoxes] = useState('');
  const [podFile, setPodFile] = useState('');
  const [dcFile, setDcFile] = useState('');
  const [siFile, setSiFile] = useState('');
  const podInputRef = useRef(null);
  const dcInputRef = useRef(null);
  const siInputRef = useRef(null);

  const handleChangePage = (event, newPage) => {
    setpage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setrowsperpage(parseInt(event.target.value, 10));
  };

  useEffect(() => {
    var date = new Date();
    var firstday = new Date(date.getFullYear(), date.getMonth(), 1);
    var lastday = new Date(
      date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
    );
    UserMailDetail();
    Getorderhdr(props.match.params.id);
    getprodctdel(props.match.params.id);
    sessionStorage.removeItem('Products');
    setfromdatee(moment(firstday).format('YYYY-MM-DD'));
    settoodate(moment(lastday).format('YYYY-MM-DD'));
  }, []);

  const Getorderhdr = async (id, id1) => {
    setProvalue([]);
    const tokent = sessionStorage.getItem('authtoken');
    const ordeheader = await axios.instance
      .get(`/POOrdr/${'Y'}/${id}`, {
        Authorization: tokent,
        'Content-Type': 'application/json',
      })
      .then(res => {
        for (const data of res.data) {
          settoodate(moment(new Date(data.Delivery_Date)).format('YYYY-MM-DD'));
          setdeliverdate(data.Order_Date);
          setremark(data.Remarks);
          setpono(data.PO_No);
          setReferenceDate(
            data.ReferenceDate === '1900-01-01T00:00:00.000Z'
              ? moment(new Date()).format('YYYY-MM-DD')
              : moment(data.ReferenceDate).format('YYYY-MM-DD'),
          );
          setRefRemarks(data.RefRemarks);
          setReferenceNumber(data.ReferenceNumber);
          setTrackId(data.TrackId);
          setCourierPartner(data.CourierPartner);
          setNoOfBoxes(Number(data.NoOfBoxes) === 0 ? '' : data.NoOfBoxes);
          if (data.PODFile) {
            setPodFile({
              name: data.PODFile ? data.PODFile : '',
              url: data.PODFile ? axios.baseURL + 'PoUpdateHrdStatus/' + data.PODFile : '',
            });
          }

          if (data.DCFile) {
            setDcFile({
              name: data.DCFile ? data.DCFile : '',
              url: data.DCFile ? axios.baseURL + 'PoUpdateHrdStatus/' + data.DCFile : '',
            });
          }

          if (data.SIFile) {
            setSiFile({
              name: data.SIFile ? data.SIFile : '',
              url: data.SIFile ? axios.baseURL + 'PoUpdateHrdStatus/' + data.SIFile : '',
            });
          }
          // comment by Yuki 27022025
          // sessionStorage.setItem('Branch_Log', data.Cus_Branchid);
        }
      });
  };

  // const getprodctdel = async id => {
  //   setProvalue([]);
  //   const tokent = sessionStorage.getItem('authtoken');
  //   const prod = await axios.instance
  //     .get(`/POOrdrDtl/${id}`, {
  //       Authorization: tokent,
  //       'Content-Type': 'application/json',
  //     })
  //     .then(async res => {
  //       sessionStorage.setItem('Products', JSON.stringify(res.data));
  //       setProvalue(res.data);

  //       let totalnetamt = [];

  //       let qtytotal = [];

  //       for (const data of res.data) {
  //         qtytotal.push(data.Order_Qty);
  //       }
  //       var qtyvalue = 0;
  //       for (let i = 0; i < qtytotal.length; i++) {
  //         qtyvalue += qtytotal[i];
  //       }
  //       //////////console.log(qtyvalue)
  //       settotalqty(qtyvalue);

  //       let totalcgstamt = [];
  //       for (const data of res.data) {
  //         var amounvalu = data.Order_Qty * data.Rate;

  //         var sgstamt = amounvalu * data.VAT_Percentage;
  //         var sgstcal = sgstamt / 100;
  //         totalcgstamt.push(sgstcal);
  //       }
  //       var totalcgstvalu = 0;
  //       for (let i = 0; i < totalcgstamt.length; i++) {
  //         totalcgstvalu += totalcgstamt[i];
  //       }
  //       settotaltax(totalcgstvalu + totalcgstvalu);

  //       let totaltamt = [];
  //       for (const data of res.data) {
  //         var amounvalu = data.Order_Qty * data.Rate;

  //         totaltamt.push(amounvalu);
  //       }
  //       var totaltvalue = 0;
  //       for (let i = 0; i < totaltamt.length; i++) {
  //         totaltvalue += totaltamt[i];
  //       }
  //       settotalamountvaluedata(totaltvalue);

  //       let totalnetamount = [];
  //       for (const data of res.data) {
  //         totalnetamount.push(data.Amount);
  //       }
  //       var totalnetcount = 0;
  //       for (let i = 0; i < totalnetamount.length; i++) {
  //         totalnetcount += totalnetamount[i];
  //       }
  //       settotalamt(totalnetcount);

  //       let totaltdisamt = [];
  //       for (const data of res.data) {
  //         totaltdisamt.push(data.DisAmt);
  //       }
  //       ////console.log(totaltdisamt)
  //       var totalamutdis = 0;
  //       for (let i = 0; i < totaltdisamt.length; i++) {
  //         totalamutdis += totaltdisamt[i];
  //       }
  //       ////console.log(totalamutdis)
  //       setTotal_discount_amt(totalamutdis);

  //       let totalIgstamt = [];
  //       for (const data of res.data) {
  //         totalIgstamt.push((data.Rate * data.Order_Qty * data.IGSTPer) / 100);
  //         ////console.log('igst', data.IGSTPer)
  //       }
  //       var totalIgstvalu = 0;
  //       for (let i = 0; i < totalIgstamt.length; i++) {
  //         totalIgstvalu += totalIgstamt[i];
  //       }
  //       ////console.log(totalIgstvalu)
  //       //settotaltax(totalcgstvalu +totalcgstvalu)
  //       setTOtaligstamt(totalIgstvalu);
  //     });
  // };

  const getprodctdel = async id => {
    try {
      setProvalue([]);

      // Get auth token
      const tokent = sessionStorage.getItem('authtoken');

      // Fetch product details
      const response = await axios.instance.get(`/POOrdrDtl/${id}`, {
        headers: {
          Authorization: tokent,
          'Content-Type': 'application/json',
        },
      });

      const data = response.data;

      // Store product details in session storage
      sessionStorage.setItem('Products', JSON.stringify(data));
      setProvalue(data);

      // Initialize totals
      let totalQty = 0;
      let totalTax = 0;
      let totalAmount = 0;
      let totalNetAmount = 0;
      let totalDiscount = 0;
      let totalIgst = 0;

      // Calculate totals
      for (const item of data) {
        const { Order_Qty, Rate, VAT_Percentage, Amount, DisAmt, IGSTPer } =
          item;

        // Quantity
        totalQty += Order_Qty;

        // Amount (excluding tax)
        const itemAmount = Order_Qty * Rate;
        totalAmount += itemAmount;

        // CGST
        const cgstAmt = (itemAmount * VAT_Percentage) / 100;
        totalTax += cgstAmt;

        // IGST
        const igstAmt = (itemAmount * IGSTPer) / 100;
        totalIgst += igstAmt;

        // Net Amount
        totalNetAmount += Amount;

        // Discount
        totalDiscount += DisAmt;
      }

      // Update states
      settotalqty(totalQty);
      settotaltax(totalTax + totalIgst); // Combine CGST and IGST
      settotalamountvaluedata(totalAmount);
      settotalamt(totalNetAmount);
      setTotal_discount_amt(totalDiscount);
      setTOtaligstamt(totalIgst);
    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  };

  const UserMailDetail = async () => {
    const tokent = sessionStorage.getItem('authtoken');
    const mailDetail = await axios.instance
      .get(
        `/UsermailDetailsin/${sessionStorage.getItem(
          'Customer_Log',
        )}/${sessionStorage.getItem('Userid')}/${sessionStorage.getItem('Approval2') === 'N' ||
          sessionStorage.getItem('Approval3') === 'N' ||
          sessionStorage.getItem('AdminUser') === 'N'
          ? 1
          : 0
        }`,
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      )
      .then(res => {
        for (const data of res.data) {
          console.log(res.data);
          setFrommail(data.Emailid);
          setTomail(data.Tomail);
          setsmptport(data.SMTPPort);
          setSMTPServer(data.SMTPServer);
          setmailpassword(data.mailpassword);
          setccmail(data.cccmail + ',' + 'developers.asktek@gmail.com');
          setcustomerss(data.User_Name);
        }
      });
  };

  const SendMail = async () => {
    if (window.confirm('Do You Want To Send Mail For Approval')) {
      const tokent = sessionStorage.getItem('authtoken');
      const Username = sessionStorage.getItem('Username');
      const approvs = await axios.instance.post(
        `/ApiForUser`,
        {
          Cus: customerss,
          Department: sessionStorage.getItem('Department'),
          Designation: sessionStorage.getItem('Designation'),
          Loginname: Username,
          Username: Frommail,
          ccmail: ccmail,
          hostname: SMTPServer,
          password: mailpassword,
          port: smptport,
          sub: 'New Purchase  Request',
          tomail: Tomail,
        },
        {
          headers: {
            Authorization: tokent,
            'Content-Type': 'application/json',
          },
        },
      );
    } else {
    }
  };

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setopen(false);
    setopen1(false);
    setopen2(false);
    setopen3(false);
  };

  useEffect(() => {
    sessionStorage.setItem('Products', '');
    const getstateid = async () => {
      const statecode = sessionStorage.getItem('StateCode');
      const Cstatecode = sessionStorage.getItem('CStateCode');
      setStatecodeee(statecode);
      setCStatecodeee(Cstatecode);
    };
    getstateid();
  }, []);

  const spinerss1 = () => {
    // setsavespinners(true);

    setTimeout(() => {
      setopeecreate(true);
      setsavespinners(false);
      setTimeout(() => {
        history.push('/PoStatusView');
        setopeecreate(false);
      }, 1000);
    }, 2000);
  };
  console.log(provalue, 'provalue');
  const UpdateData = async () => {
    setsavespinners(true);
    if (provalue.length != 0) {
      let prodvalue = [];
      let allDelivered = true;
      let allPending = true;
      const token = sessionStorage.getItem('AuthToken');
      const productsvalue = sessionStorage.getItem('Products');
      let product = JSON.parse(productsvalue);
      console.log(product, 'product');
      // Looping Status Update
      for (const item of provalue) {
        const status = item && item.POStatus ? item.POStatus.toLowerCase() : "";

        if (status !== "delivered") {
          allDelivered = false;
        }

        if (status !== "pending") {
          allPending = false;
        }
      }

      let finalStatus = "Partial"; // default
      if (allDelivered) {
        finalStatus = "Delivered";
      } else if (allPending) {
        finalStatus = "Accepted";
      }

      console.log(finalStatus, 'finalStatus');
      prodvalue.push(product);
      const customerid = sessionStorage.getItem('Customer_Log');
      const Branchlog = sessionStorage.getItem('Branch_Log');
      const createdby = sessionStorage.getItem('Userid');

      const formData = new FormData();
      if (podFile) {
        formData.append('PODFile', podFile instanceof File ? podFile : podFile.name);
      }
      if (dcFile) {
        formData.append('DCFile', dcFile instanceof File ? dcFile : dcFile.name); // You can use any filename
      }
      if (siFile) {
        formData.append('SIFile', siFile instanceof File ? siFile : siFile.name);
      }

      formData.append('Order_Id', props.match.params.id);
      formData.append('ReferenceDate', referenceDate);
      formData.append('ReferenceNumber', referenceNumber || '');
      formData.append('RefRemarks', refremarks || '');
      formData.append('POStatus', finalStatus);
      formData.append('TrackId', TrackId);
      formData.append('CourierPartner', CourierPartner);
      formData.append('NoOfBoxes', NoOfBoxes);

      const createpohed = await axios.instance
        .put(
          `/UpdatePOHdrStatus`,
          // {
          //   Order_Id: props.match.params.id,
          //   ReferenceDate: referenceDate,
          //   ReferenceNumber: referenceNumber,
          //   RefRemarks: refremarks,
          // }
          formData,
          {
            headers: {
              Authorization: token,
            },
          },
        )
        .then(async res => {
          const deleteproduct = await axios.instance.delete(
            `/PoDeltedtl/${props.match.params.id}`,
          );
          const productsvalue = sessionStorage.getItem('Products');
          const Orderid = sessionStorage.getItem('Order_Id');
          let product = JSON.parse(productsvalue);
          console.log(provalue, 'provalue');
          for (const data of provalue) {
            const productcoll = Object.assign(data, {
              Order_Id: parseInt(props.match.params.id),
              OpType: 'New',
            });

            const createpohed = await axios.instance
              .post(
                `/PODtl`,
                productcoll,

                {
                  headers: {
                    Authorization: token,
                    'Content-Type': 'application/json',
                  },
                },
              )
              .then(res => {
                sessionStorage.removeItem('Products');
              });
          }
        })
        .then(() => { });
      spinerss1();
      // SendMail();

      setopeecreate(true);
      setTimeout(() => {
        setopeecreate(false);
      }, 3000);
    } else {
      setopen4(true);
      setTimeout(() => {
        setopen4(false);
        setsavespinners(false);
      }, 2000);
    }
  };
  console.log(provalue, 'provalue');

  const handleDeliveryStatusChange = value => {
    const updatedProvalue = provalue.map(item => ({
      ...item,
      POStatus: value, // Apply the same status to all rows
    }));
    setProvalue(updatedProvalue);
    console.log('updatedProvalue', updatedProvalue);
  };

  const handleRemarksChange = value => {
    const updatedProvalue = provalue.map(item => ({
      ...item,
      PoRemarks: value, // Apply the same remark to all rows
    }));
    setProvalue(updatedProvalue);
  };

  const handleStatusChange = (index, newStatus) => {
    const updatedProvalue = [...provalue];
    updatedProvalue[index].POStatus = newStatus;
    setProvalue(updatedProvalue);
    console.log('updatedProvalue[index]', updatedProvalue[index]);
  };

  const handleRemarksChangeRow = (index, newRemarks) => {
    const updatedProvalue = [...provalue]; // Make a copy of the current state
    updatedProvalue[index].PoRemarks = newRemarks; // Update the specific row's PoRemarks
    setProvalue(updatedProvalue); // Update the state
  };

  const handlePreviewClick = (file) => {
    if (!file) return;

    // Check if it's a newly uploaded file (File object) or existing file (has url property)
    const isNewFile = file instanceof File;
    const extension = file.name.split('.').pop().toLowerCase();
    const imageExtensions = ['jpg', 'jpeg', 'png'];

    if (imageExtensions.includes(extension)) {
      // It's an image
      if (isNewFile) {
        // For newly uploaded files
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
        setPreviewModal(true);
      } else {
        // For existing files from server
        setPreviewUrl(file.url);
        setPreviewModal(true);
      }
    } else {
      // It's a document - always open in new tab
      const fileUrl = isNewFile ? URL.createObjectURL(file) : file.url;
      window.open(fileUrl, '_blank');

      // Clean up object URL if we created one
      if (isNewFile) {
        setTimeout(() => URL.revokeObjectURL(fileUrl), 100);
      }
    }
  };

  return (
    <>
      <Card className="titledefects">
        <CardBody>
          <div>
            <h6 className="titlepo" style={{ color: 'white' }}>
              Update Sales Order Status
            </h6>
          </div>

          <div>
            <Card className="p-3">
              <Row>
                <Col md={2}>
                  <div className="d-flex flex-row gap-2 justify-content-start align-items-start">
                    <Label for="referenceNumber pl-2">Po No:</Label>
                    <b className="mx-2">{pono}</b>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex flex-row gap-2 justify-content-start align-items-start">
                    <Label for="referenceNumber pl-2">Po Date:</Label>
                    <b className="mx-2">
                      {moment(deliverdate).format('DD-MM-YYYY')}
                    </b>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="d-flex flex-row gap-2 justify-content-start align-items-start">
                    <Label for="referenceNumber pl-2">Delivery Date:</Label>
                    <b className="mx-2">
                      {moment(deliverdate).format('DD-MM-YYYY')}
                    </b>
                  </div>
                </Col>

                {/* <Col md={12}>
                  <div className="d-flex flex-column justify-content-start align-items-start">
                    <Label for="referenceDate font-weight-bold">
                      Terms & Conditions
                    </Label>
                    <Input
                      type="text"
                      name="referenceDate"
                      id="referenceDate"
                      value={remark}
                      onChange={e => setremark(e.target.value)}
                    />
                  </div>
                </Col> */}
              </Row>
              <Form>
                <Row className="my-2">
                  <Col md={3}>
                    <FormGroup>
                      <Label
                        for="referenceNumber"
                        className="font-weight-bold "
                      >
                        Reference Number
                      </Label>
                      <Input
                        type="text"
                        name="referenceNumber"
                        id="referenceNumber"
                        value={referenceNumber}
                        onChange={e => setReferenceNumber(e.target.value)}
                        placeholder="Enter reference number"
                      />
                    </FormGroup>
                  </Col>

                  <Col md={3}>
                    <FormGroup>
                      <Label for="referenceDate" className="font-weight-bold ">
                        Reference Date
                      </Label>
                      <Input
                        type="date"
                        name="referenceDate"
                        id="referenceDate"
                        value={referenceDate}
                        onChange={e =>
                          setReferenceDate(
                            moment(e.target.value).format('YYYY-MM-DD'),
                          )
                        }
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <Label for="refRemarks" className="font-weight-bold ">
                        Remarks
                      </Label>
                      <Input
                        type="text"
                        name="remarks"
                        id="refRemarks"
                        value={refremarks}
                        onChange={e => setRefRemarks(e.target.value)}
                        placeholder="Enter remarks here"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label
                        for="TrackId"
                        className="font-weight-bold "
                      >
                        Tracker Id
                      </Label>
                      <Input
                        type="text"
                        name="TrackId"
                        id="TrackId"
                        value={TrackId}
                        onChange={e => setTrackId(e.target.value)}
                        placeholder="Enter Tracker Id"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={5}>
                    <FormGroup>
                      <Label
                        for="CourierPartner"
                        className="font-weight-bold "
                      >
                        Courier Partner
                      </Label>
                      <Input
                        type="text"
                        name="CourierPartner"
                        id="CourierPartner"
                        value={CourierPartner}
                        onChange={e => setCourierPartner(e.target.value)}
                        placeholder="Enter Courier Partner"
                      />
                    </FormGroup>
                  </Col>
                  <Col md={3}>
                    <FormGroup>
                      <Label
                        for="NoOfBoxes"
                        className="font-weight-bold "
                      >
                        No Of Boxes
                      </Label>
                      <Input
                        type="number"
                        name="NoOfBoxes"
                        id="NoOfBoxes"
                        value={NoOfBoxes}
                        onChange={e => setNoOfBoxes(e.target.value)}
                        placeholder="Enter No Of Boxes"
                      />
                    </FormGroup>
                  </Col>
                  <Col xs={12} className="mb-4">
                    <Paper
                      elevation={0}
                      sx={{
                        border: '1px solid #e0e0e0',
                        borderRadius: 1,
                        p: 3,
                        backgroundColor: '#f9f9f9',
                      }}
                    >
                      <Typography
                        variant="subtitle1"
                        sx={{
                          mb: 2,
                          color: 'text.primary',
                          fontWeight: 600,
                          borderBottom: '1px solid #eee',
                          pb: 1,
                        }}
                      >
                        Document Upload
                      </Typography>

                      <Grid container mt={1} spacing={3}>
                        {/* POD Document */}
                        <Grid item md={4} xs={12}>
                          <DocumentUploadCard
                            title="Proof of Delivery (POD)"
                            inputRef={podInputRef}
                            file={podFile}
                            onFileChange={file => setPodFile(file)}
                            onPreview={handlePreviewClick}
                            onRemove={() => setPodFile(null)}
                          />
                        </Grid>

                        {/* DC Document */}
                        <Grid item md={4} xs={12}>
                          <DocumentUploadCard
                            title="Delivery Challan (DC)"
                            inputRef={dcInputRef}
                            file={dcFile}
                            onFileChange={file => setDcFile(file)}
                            onPreview={handlePreviewClick}
                            onRemove={() => setDcFile(null)}
                          />
                        </Grid>

                        {/* SI Document */}
                        <Grid item md={4} xs={12}>
                          <DocumentUploadCard
                            title="Sales Invoice (SI)"
                            inputRef={siInputRef}
                            file={siFile}
                            onFileChange={file => setSiFile(file)}
                            onPreview={handlePreviewClick}
                            onRemove={() => setSiFile(null)}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </Col>
                </Row>
              </Form>
              <div className="Tabelinspections">
                <TableContainer>
                  <Table className="InspectionTbls" aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="Center">S.no</TableCell>
                        <TableCell align="left">Branch Name</TableCell>
                        <TableCell align="left">Products</TableCell>
                        <TableCell align="Center">Qty</TableCell>
                        <TableCell align="Center">Uom</TableCell>
                        <TableCell align="Center">Rate</TableCell>
                        <TableCell align="Center">Dis%</TableCell>
                        <TableCell align="Center">Tax%</TableCell>
                        <TableCell align="Center" className="px-2">
                          Amount
                        </TableCell>
                        <TableCell
                          align="Center"
                          className="px-2"
                          style={{ whiteSpace: 'nowrap' }}
                        >
                          Delivery Status {'  '}
                          <input
                            type="checkbox"
                            checked={isDeliveryChecked}
                            onChange={e =>
                              setIsDeliveryChecked(e.target.checked)
                            }
                          />
                        </TableCell>
                        <TableCell align="Center" className="px-2">
                          Remarks
                          {'  '}
                          <input
                            type="checkbox"
                            checked={isRemarksChecked}
                            onChange={e =>
                              setIsRemarksChecked(e.target.checked)
                            }
                          />
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    {provalue.map((data, index) => (
                      <TableBody>
                        <TableRow>
                          <TableCell color="red" align="center" width="170">
                            {index + 1}
                          </TableCell>
                          <TableCell width="300px" align="left">
                            {data.Branch_Name}
                          </TableCell>
                          <TableCell width="200px" align="left">
                            {data.Product_Details_Description}
                          </TableCell>

                          <TableCell width="200px" align="center">
                            {data.Order_Qty}
                          </TableCell>
                          <TableCell width="200px" align="center">
                            {data.UOM_Description}
                          </TableCell>
                          <TableCell width="170" align="center">
                            {data.Rate}
                          </TableCell>

                          <TableCell color="red" align="center" width="170">
                            {data.DisPer}
                          </TableCell>

                          <TableCell color="red" align="Center" width="170">
                            {data.GSTPer != 0 ? data.GSTPer : data.IGSTPer}%
                          </TableCell>

                          <TableCell
                            color="red"
                            align="right"
                            width="100"
                            className="px-2"
                          >
                            {numeral(data.Amount).format('0,0.00')}
                          </TableCell>
                          {/* Editable POStatus as a dropdown */}
                          <TableCell
                            align="center"
                            width="170"
                            className="px-2"
                          >
                            <Input
                              style={{ minWidth: '130px' }}
                              type="select"
                              name="status"
                              id="poStatusSelect"
                              value={
                                data.POStatus === '' ? 'pending' : data.POStatus
                              }
                              onChange={e => {
                                if (isDeliveryChecked) {
                                  handleDeliveryStatusChange(e.target.value);
                                } else {
                                  handleStatusChange(index, e.target.value);
                                }
                              }}
                            >
                              <option value="delivered">Delivered</option>
                              <option value="partial">Partial</option>
                              <option value="pending">Pending</option>
                              <option value="In Transit">In Transit</option>
                            </Input>
                          </TableCell>

                          {/* Editable Remarks as an input field */}
                          <TableCell
                            align="center"
                            width="170"
                            className="px-2"
                          >
                            <Input
                              type="text"
                              name="remarks"
                              style={{ minWidth: '150px' }}
                              id="poRemarks"
                              value={data.PoRemarks}
                              onChange={e => {
                                if (isRemarksChecked) {
                                  handleRemarksChange(e.target.value);
                                } else {
                                  handleRemarksChangeRow(index, e.target.value);
                                }
                              }}
                              placeholder="Enter remarks here"
                            />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    ))}
                    <TableRow>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center">
                        <b>Total Qty</b>
                      </TableCell>
                      <TableCell align="center" style={{ color: 'red' }}>
                        {totalqty}
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell
                        align="center"
                        style={{ color: 'red' }}
                      ></TableCell>
                      <TableCell align="right">
                        <b>Total Amount</b>
                      </TableCell>
                      <TableCell
                        align="right"
                        style={{ color: 'red' }}
                        className="px-2"
                      >
                        {numeral(totalamt).format('0,0.00')}
                      </TableCell>
                      <TableCell align="center"></TableCell>
                      <TableCell align="center"></TableCell>
                    </TableRow>
                  </Table>
                </TableContainer>
              </div>

              <TablePagination
                component="div"
                rowsPerPageOptions={pages}
                count={provalue.length}
                rowsPerPage={rowsperpage}
                page={page}
                onChangePage={handleChangePage}
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
              <div className="mt-3 d-flex justify-content-center">
                <Button1
                  onClick={() => {
                    // setTimeout(() => {
                    history.push('/PoStatusView');
                    // setopeecreate(false);
                    // }, 1000);
                  }}
                  color="danger"
                  className="adbtn2 "
                >
                  Back
                </Button1>

                <Button1
                  onClick={UpdateData}
                  color="success"
                  className="adbtn2 ml-3"
                >
                  Update
                </Button1>
              </div>
            </Card>

            <Modal
              isOpen={previewModal}
              toggle={() => setPreviewModal(false)}
              centered
              size="lg"
            >
              <ModalBody className="text-center">
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{ maxWidth: '100%', height: 'auto' }}
                />
              </ModalBody>
            </Modal>

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              autoHideDuration={2000}
              onClose={handleClose}
              message="product added successfully"
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open1}
              autoHideDuration={2000}
              onClose={handleClose}
              message="Defect category   updated successfully"
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open2}
              autoHideDuration={2000}
              onClose={handleClose}
              message="Product  deleted successfully"
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open3}
              autoHideDuration={2000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                Product Already exists
              </Alert>
            </Snackbar>

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open4}
              autoHideDuration={2000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                Atleast add one Product to complete a Po
              </Alert>
            </Snackbar>

            <Backdrop open={savespinners} className={classes.backdrop}>
              <Spinner name="ball-spin-fade-loader" color="#fafafa" />
            </Backdrop>

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open}
              autoHideDuration={2000}
              onClose={handleClose}
              message="product added successfully"
            />

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={opeecreate}
              autoHideDuration={2000}
              onClose={handleClose}
              message="Po Updated successfully"
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open1}
              autoHideDuration={2000}
              onClose={handleClose}
              message="Purchase order   updated successfully"
            />
            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open2}
              autoHideDuration={2000}
              onClose={handleClose}
              message="Product   deleted successfully"
            />

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open3}
              autoHideDuration={2000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                Product Already exists
              </Alert>
            </Snackbar>

            <Snackbar
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={open4}
              autoHideDuration={2000}
              onClose={handleClose}
            >
              <Alert onClose={handleClose} severity="error">
                Atleast add one Product to complete a Po
              </Alert>
            </Snackbar>
          </div>
        </CardBody>
      </Card>
    </>
  );
}

export default POStatusUpdate;
